import { render, staticRenderFns } from "./OnboardingDetails.vue?vue&type=template&id=77a0c028&scoped=true&"
import script from "./OnboardingDetails.vue?vue&type=script&lang=ts&"
export * from "./OnboardingDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingDetails.vue?vue&type=style&index=0&id=77a0c028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a0c028",
  null
  
)

export default component.exports